// ----------------------------------------------------------------------------
// Nombre del Programa : interceptor
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase para validar rutas y navegaciones de la pagina
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import axios from 'axios';
import { requestCompleted, requestStarted } from '../stores/App';
import { logout } from '../stores/AuthUser';
import { useDispatch } from 'react-redux';

const setUpInterceptor = (store: any, navigate: any) => {
  axios.interceptors.request.use((config) => {
    store.dispatch(requestStarted());
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      if (
        response.status === 401 &&
        !!window.location.pathname.replace('/', '')
      ) {
        navigate('/', { replace: true });
        store.dispatch(logout());
      }else if(response.status === 401){
        navigate('/', { replace: true });
        store.dispatch(logout());
        store.dispatch(requestCompleted());
        return response;
      }
      store.dispatch(requestCompleted());
      return response;
    },
    (error) => {
      if (
        error.response.status === 401 &&
        !!window.location.pathname.replace('/', '')
      ) {
        //Modificacion: Marca de Inicio WII C-24-1229-24
        //navigate('/', { replace: true });
        //Modificacion: Marca de Fin WII C-24-1229-24
        navigate('/', { replace: true });
        store.dispatch(logout());
      }else if(error.response.status === 401){
        navigate('/', { replace: true });
        store.dispatch(logout());
      }
      store.dispatch(requestCompleted());
      return error;
    }
  );
};

export default setUpInterceptor;
